import { NavigationItem } from './core/Navigation';

interface BreadcrumbProps {
  primary: NavigationItem | null;
  sub: NavigationItem | null;
}

export const Breadcrumb = ({ primary, sub }: BreadcrumbProps) => {
  if (!primary) {
    return null;
  }

  return (
    <div className="min-w-0 space-x-0.5 truncate text-sm font-medium text-text-primary">
      <span>{primary.label}</span>
      {sub && (
        <>
          <span className="text-text-secondary"> / </span>
          <span>{sub.breadcrumbLabel ?? sub.label}</span>
        </>
      )}
    </div>
  );
};
